

import { getAuth, onAuthStateChanged } from 'firebase/auth';

// Retreives firebase token. Needs to be handled seperatly to avoid imports conflicts between parktory.ts and authApi etc.
export const getCurrToken = async() => {

    const auth = getAuth();
    return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                const token = user.getIdToken(); // fb method
                resolve(token);
            } else {
                reject(new Error('No authenticated user'));
            }
        });
    });
};